import { Injectable } from '@angular/core';

import { Phone, QuoteModel } from '@bytel/bytel-sales';
import { CheckoutStorageService } from '@bytel/checkout';

import { BasicObject } from '../interfaces/checkout.interface';
import { MobileRecoveryModel } from '../models/mobile-recovery.model';

@Injectable({
    providedIn: 'root',
})
export class MobileRecoveryRepository {
    private _storageKey: string = 'mobile_recovery_current_product';

    private _storageKeys: string[] = [
        'mobile_recovery_current_product',
        'mobileRecoveryCurrentStep',
        'recoveryDevisRepriseMobileOut',
    ];
    public constructor(private storageService: CheckoutStorageService) {}

    public getMobileRecovery(quote: QuoteModel): MobileRecoveryModel {
        if (!quote || !quote.getProductByType(Phone)) {
            return null;
        }

        const recoveryData: BasicObject = this.storageService.get(this._storageKey, false);
        if (!recoveryData) {
            return null;
        }

        return new MobileRecoveryModel({
            product: recoveryData.product,
            recovery: recoveryData.recovery,
            id: recoveryData.recovery_id,
            status: recoveryData.status,
            step: recoveryData.step,
            iban: recoveryData.iban,
        });
    }

    public remove(productId: string): void {
        this._storageKeys.forEach((key) => {
            if (key === 'recoveryDevisRepriseMobileOut') {
                sessionStorage.removeItem(`${key}-${productId}`);
            } else {
                this.storageService.remove(key, false);
            }
        });
    }
}
